import Vue from 'vue'
import App from './App.vue'
import VueScrollTo from 'vue-scrollto'
import { VueHorizontalTimeline } from "vue-horizontal-timeline"

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.use(VueHorizontalTimeline)

new Vue({
  render: h => h(App),
}).$mount('#app')
